module.exports = __webpack_public_path__ + "static/media/mil3south.06fc007c.png";